/**
 * Format languages data for dropdown display
 * @param {Array} languages - The languages array from the API
 * @return {Array} Formatted languages with unique keys for dropdown
 */
const formatLanguages = (languages) => {
  // Handle empty or invalid input
  if (!languages || !Array.isArray(languages) || languages.length === 0) {
    return []
  }

  // Create a map to track used keys and avoid duplicates
  const keyMap = new Map()

  return languages
    .map((language, index) => {
      // Ensure language has required fields
      if (!language || !language.name) {
        console.warn('Invalid language object encountered:', language)
        return null // Will be filtered out
      }

      // Create a unique value from the language code or index if code is missing
      const languageValue = language.iso_639_1_code || `lang_${index}`

      // Generate a unique key to avoid React warnings
      // If we've seen this value before, append an index to make it unique
      let key = languageValue
      if (keyMap.has(key)) {
        const count = keyMap.get(key) + 1
        keyMap.set(key, count)
        key = `${key}_${count}`
      } else {
        keyMap.set(key, 1)
      }

      return {
        key, // Unique key for React
        label: language.name, // Display name
        value: language.name, // Value for form
      }
    })
    .filter(Boolean) // Remove any null entries
}

export default formatLanguages
